import { Component, inject, Input, OnInit } from '@angular/core';
import { DictionaryService } from '@cudirect/shared-ui-library';
import { Membership } from './oao-eligibility.types';
import { CorePageBaseComponent } from '@workflow/dynamic-render/page/shared/core-page-base.component';
import { WorkflowPageNavigationService } from '@workflow/service/workflow-page-navigation/workflow-page-navigation.service';
import { WorkflowWidgetEventServiceService } from '@workflow/widget/workflow-widget-event.service';
import { OAOCustomPage } from '../oao-custom-page.types';
import { StatefulService } from '@app/service/stateful.service';
/** Elegibility component for OAO flow */
@OAOCustomPage('oao-eligibility')
@Component({
  selector: 'ecp-oao-eligibility',
  templateUrl: './oao-eligibility.component.html',
  standalone: false
})
export class OaoEligibilityComponent extends CorePageBaseComponent implements OnInit {
  private readonly statefulService = inject(StatefulService);

  /** It has features and shares of Membership */
  @Input()
  public Membership: Membership;

  /** Checklist Description */
  public checklistDescription: string;
  /** Checklist Enabled Status */
  public checklistEnabled: boolean;

  constructor(
    public workflowPageNavigationService: WorkflowPageNavigationService,
    public readonly EventService: WorkflowWidgetEventServiceService,
    private readonly dictionaryService: DictionaryService
  ) {
    super(workflowPageNavigationService, EventService);
  }

  public ngOnInit(): void {
    const checklist = this.statefulService.wrap('ss:oaoMemberInformation/membership/checklistdescription').valueString;
    this.checklistEnabled = this.statefulService.wrap('ss:oaoMemberInformation/membership/isEnabledChecklist').value as boolean;
    this.checklistDescription = checklist ? checklist : this.dictionaryService.read('eligibility/checklistdescription');
  }
}
